import React, { useEffect, useState } from "react";
import "./PinLocation.css";
import { holes } from "./CourseInfo";
import Distances from "./Distances";
import { db } from "./firebase";
import { useStateValue } from "./StateProvider";

const PinLocation = () => {
  const [{ hole }, dispatch] = useStateValue();
  const [{ user }] = useStateValue();
  const [positions, setPositions] = useState([]);
  const [accuracy, setAccuracy] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [centerAcc, setCenterAcc] = useState("");

  useEffect(() => {
    localStorage.setItem("hole", JSON.stringify(hole));
    setPositions([]);
    setLatitude("");
    setLongitude("");
    setAccuracy("");
    getCenterGreenFirebase();
  }, [hole]);

  const getCenterGreenFirebase =() => {
    const ev = db
      .collection("courselocations")
      .doc("hole" + hole)
      .collection("green")
      .doc("center")
      .onSnapshot((snapshot) => {
      //get most current center location
     
        if (snapshot.data() !== undefined)
         {
          // console.log("center", snapshot.data());
          setLatitude(snapshot.data().lat);
          setLongitude(snapshot.data().long);
          setCenterAcc(snapshot.data().acc)
        }
      });
  };

 





  const nextHole = () => {
    dispatch({
      type: "NEXTHOLE",
      num: { hole },
    });
  };

  const lastHole = () => {
    dispatch({
      type: "LASTHOLE",
      num: { hole },
    });
  };
  const beep = () => {
    var snd = new Audio(
      "data:audio/wav;base64,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"
    );
    snd.play();
  };
  //get distances
  const getCoordinates = (location, site) => {
    var point;
    if (navigator.geolocation) {
      //set up for loop to get more accuracy
      //Dummy one, which will result in a working next statement.
      // for (let i = 0; i < 10; i++) {
      //   navigator.geolocation.getCurrentPosition(
      //     function () {},
      //     function () {},
      //     { enableHighAccuracy: true, timeout: 2000, maximumAge: 0 }
      //   );
      // }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          point = {
            lat: position.coords.latitude,
            long: position.coords.longitude,
          }; // example of point location

          // save when accuracy <5 m ******************************************************
          if (position.coords.accuracy > 5) {
            getCoordinates(location, site);
          } else {
            beep();
            if(site !== "pin"){
            savePosition(
                location,
                site,
                point.lat,
                point.long,
                position.coords.accuracy
            );
          }else{
              savePinPosition(
                point.lat,
                point.long,
                position.coords.accuracy)
            }
          }
          setPositions({
            ...positions,
            [site]: {
              lat: point.lat,
              long: point.long,
              acc: position.coords.accuracy,
            },
          });
          setAccuracy(position.coords.accuracy);
        },
        (error) => alert(error.message),
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 0, distanceFilter: 5}
      );
    }
    const savePinPosition = ( lat, long, acc) => {
      db.collection("courselocations")
        .doc("hole" + hole)
        .set({
          lat: lat,
          long: long,
          acc: acc,
          user: user.email,
          timestamp: Date(),
        })
        .then(() => {
          console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    };  };


  const savePosition = (location, site, lat, long, acc) => {
    db.collection("courselocations")
      .doc("hole" + hole)
      .collection(location)
      .doc(site)
      .set({
        lat: lat,
        long: long,
        acc: acc,
        user: user.email,
        timestamp: Date(),
      })
      .then(() => {
        console.log("Document successfully written!");
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
  };

  const pos = (loc, coord) => {
    return ((positions || {})[loc] || {})[coord] || {};
  };

  const getDistance = (lat, long) => {
    if (lat && long) {
      const distance = getDistanceFromLatLonInYds(
        lat,
        long,
        //center green from firebase
        latitude,
        longitude
      );
      return distance.toFixed(2);
    }
  };

  const getDistanceFromLatLonInYds = (lat1, lon1, lat2, lon2) => {
    let R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2 - lat1); // deg2rad below
    let dLon = deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in km
    d = d * 1093.6132983; //convert to yards
    return d;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  return (
    <div className="holepage">
      <div className="holepage__title">
        <div className="holepage__topline">
          <div className="holepage__back">
            <h1 onClick={lastHole}>{hole !== 1 ? "<<<<" : ""}</h1>
          </div>
          <h1>Hole #{hole}</h1>
          <div className="holepage__next">
            <h1 onClick={nextHole}>{hole !== 18 ? ">>>>" : ""}</h1>
          </div>
        </div>
        <div className="holepage__tables">
          <table className="holepage__yardages">
            <tbody>
              <tr>
                <th colSpan="3">Yardages </th>
              </tr>
              <tr>
                <td className="holepage__yardagesblue">{holes[hole].blue}</td>
                <td className="holepage__yardageswhite">{holes[hole].white}</td>
                <td className="holepage__yardagesgold">{holes[hole].gold}</td>
              </tr>
            </tbody>
          </table>

          <table className="holepage__info">
            <tbody>
              <tr>
                <th>PAR</th>
                <th>Rating</th>
              </tr>
              <tr>
                <td className="par">{holes[hole].par}</td>
                <td>{holes[hole].rating}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="green">
        <div className="accuracy">Accuracy:{accuracy}</div>

        <div className="measurement">
          <button
            className="saveback"
            onClick={() => getCoordinates("green", "back")}
          >
            Back of Green:
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {typeof pos("back", "lat") == "number" && pos("back", "lat")}{" "}
              </span>
              <span className="loc__coords">
                {typeof pos("back", "long") == "number" && pos("back", "long")}{" "}
              </span>
              {/* <span className="loc__coords">{positions.back.acc} </span> */}
            </div>
            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("back", "lat") == "number" && pos("back", "lat"),
                  typeof pos("back", "long") == "number" && pos("back", "long")
                )}
              </span>
            </div>{" "}
          </div>{" "}
        </div>

        <div className="measurement">
          <button
            className="savepin"
            onClick={() => getCoordinates("green", "pin")}
          >
            Pin Location:
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {" "}
                {typeof pos("pin", "lat") == "number" && pos("pin", "lat")}{" "}
              </span>
              <span className="loc__coords">
                {" "}
                {typeof pos("pin", "long") == "number" &&
                  pos("pin", "long")}{" "}
              </span>
            </div>

            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("pin", "lat") == "number" && pos("pin", "lat"),
                  typeof pos("pin", "long") == "number" && pos("pin", "long")
                )}
              </span>
            </div>
          </div>
          {" "}
        </div> 

        <div className="measurement">
          <button
            className="savecenter"
            onClick={() => getCoordinates("green", "center")}
          >
            {" "}
            Center of Green:{" "}
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {typeof pos("center", "lat") == "number" &&
                  pos("center", "lat")}
              </span>
              <span className="loc__coords">
                {typeof pos("center", "long") == "number" &&
                  pos("center", "long")}
              </span>
            </div>
            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("center", "lat") == "number" &&
                    pos("center", "lat"),
                  typeof pos("center", "long") == "number" &&
                    pos("center", "long")
                )}
              </span>
            </div>
            <span>Stored accuracy: {centerAcc}</span>
          </div>{" "}
        </div>

        <div className="measurement">
          <button
            className="savefront"
            onClick={() => getCoordinates("green", "front")}
          >
            Front of Green:
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {typeof pos("front", "lat") == "number" && pos("front", "lat")}
              </span>
              <span className="loc__coords">
                {typeof pos("front", "long") == "number" &&
                  pos("front", "long")}
              </span>
            </div>
            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("front", "lat") == "number" && pos("front", "lat"),
                  typeof pos("front", "long") == "number" &&
                    pos("front", "long")
                )}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="fairway">
        <div className="measurement">
          <button
            className="save100"
            onClick={() => getCoordinates("fairway", "y100")}
          >
            100 YD Marker:
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {typeof pos("y100", "lat") == "number" && pos("y100", "lat")}
              </span>
              <span className="loc__coords">
                {typeof pos("y100", "long") == "number" && pos("y100", "long")}
              </span>
            </div>
            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("y100", "lat") == "number" && pos("y100", "lat"),
                  typeof pos("y100", "long") == "number" && pos("y100", "long")
                )}
              </span>
            </div>{" "}
          </div>{" "}
        </div>

        <div className="measurement">
          <button
            className="save150"
            onClick={() => getCoordinates("fairway", "y150")}
          >
            150 YD Marker:
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {typeof pos("y150", "lat") == "number" && pos("y150", "lat")}
              </span>
              <span className="loc__coords">
                {typeof pos("y150", "long") == "number" && pos("y150", "long")}
              </span>
            </div>
            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("y150", "lat") == "number" && pos("y150", "lat"),
                  typeof pos("y150", "long") == "number" && pos("y150", "long")
                )}
              </span>
            </div>{" "}
          </div>{" "}
        </div>

        <div className="measurement">
          <button
            className="save200"
            onClick={() => getCoordinates("fairway", "y200")}
          >
            200 YD Marker:
          </button>
          <div className="coords__yds">
            <div className="loc__lat__long">
              <span className="loc__coords">
                {typeof pos("y200", "lat") == "number" && pos("y200", "lat")}
              </span>
              <span className="loc__coords">
                {typeof pos("y200", "long") == "number" && pos("y200", "long")}
              </span>
            </div>
            <div>
              <span className="loc__dist">
                {getDistance(
                  typeof pos("y200", "lat") == "number" && pos("y200", "lat"),
                  typeof pos("y200", "long") == "number" && pos("y200", "long")
                )}
              </span>
            </div>{" "}
          </div>{" "}
        </div>

        {/* <Distances /> */}
      </div>
    </div>
  );
};

export default PinLocation;
